<template>
  <div
    :class="[$.toast_cmp]"
  >
    <div
      :class="$.message"
      v-html="locales('error_tasks_api_operation')"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      locales: __,
    };
  },
};
</script>

<style module="$" lang="less">
@import "../less/_fonts.less";
@import "../less/_mixins.less";
@import "../less/_variables.less";

.toast_cmp {
  .FontLatoRegular;
  .fs(16px, 24px);
  color: #191919;
}
</style>
